const getCurrentLegend = (state) => {
  return state.currentLegend
}
const getAllLegend = (state) => {
  return state.allLegend
}
const getEditLegend = (state) => {
  return state.editLegend
}
const getLoadingLegend = (state) => {
  return state.loadingLegend
}

export default {
  getLoadingLegend,
  getCurrentLegend,
  getAllLegend,
  getEditLegend
}
